import { useEntityMutation } from './useEntityMutation';
import { clientMutationConfig } from '@/lib/entity-configs';

/**
 * Hook per actualitzar clients
 * @deprecated Usa useEntityMutation amb clientMutationConfig directament
 */
export function useUpdateClient() {
  const { updateMutation } = useEntityMutation(clientMutationConfig);
  return updateMutation;
}
